import { render, staticRenderFns } from "./Parceiro.vue?vue&type=template&id=651e3888"
import script from "./Parceiro.vue?vue&type=script&lang=js"
export * from "./Parceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports